import type { RedoBadgeColor } from "@redotech/redo-web/arbiter-components/badge/redo-badge";

export function binTypeLabel(binType: string | null | undefined): string {
  // tslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- TODO: grandfather FIXME
  switch (binType) {
    case "bin":
      return "Pickable bin";
    case "storage":
      return "Backstock";
    case "receiving":
      return "Receiving";
    default:
      return "Bin";
  }
}

export function binTypeColor(
  binType: string | null | undefined,
): RedoBadgeColor {
  // tslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- TODO: grandfather FIXME
  switch (binType) {
    case "bin":
      return "success";
    case "storage":
      return "blue";
    case "receiving":
      return "orange";
    default:
      return "gray";
  }
}
